module.exports = __webpack_public_path__ + "img/preview.4e1aea1e.webp";